(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  
// var jq = jQuery.noConflict();
// jq(document).ready(function() {
$(document).ready(function() {
  
  // Get the browset language
  var browserLanguage = navigator.language || navigator.userLanguage;

  const $messageContainer = $(".country-and-language");
  const $continueButton = $(".continue-button"); 
  const $closeButton = $(".close-button"); 

  // Function to check if a cookie exists
  function checkCookie(name) {
    return document.cookie.split(';').some(cookie => {
      const [cookieName] = cookie.split('=').map(item => item.trim());
      return cookieName === name;
    });
  }

  // Function to create a cookie
  function createCookie(name, value, daysToExpire) {
    const date = new Date();
    date.setTime(date.getTime() + (daysToExpire * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + "; " + expires;
  }

  // Code to check for the existence of a cookie and create it if it doesn't exist
  const cookieName = "languageConfig";

  if (!checkCookie(cookieName)) {     
      $messageContainer.css("display", "flex");
  } 
  if($messageContainer.is(':visible')){
      $('.announcement-bar').css("display", "none");      
  }

  $continueButton.click(function() {
    $messageContainer.hide();
    createCookie(cookieName, "setToFrench", 365); // Example: Creates a cookie that expires in one year
    // sessionStorage.setItem("messageChecked", "true");
  })

  $closeButton.click(function() {
    $messageContainer.hide();
    createCookie(cookieName, "continueToEnglish", 365); // Example: Creates a cookie that expires in one year
    // sessionStorage.setItem("messageChecked", "true");
  })
  
  // Add animation to the dropdown
  $('.relative').click(function(){
    if($('.country-selected').attr('aria-expanded') == 'true'){
      $('.dropdown-svg').addClass('dropped-down') 
    }else{
      $('.dropdown-svg').removeClass('dropped-down') 
      $('.dropdown-svg').css('transition', '0.5s') 
    }
  }) 

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["first-to-be-made-archive"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeArchive = (root) => {
      if (root.dataset.initialized === 'true') return;

      const source = root.querySelector('[data-ftbm-archive-source]');
      const monthsRoot = root.querySelector('[data-ftbm-archive-months]');
      const maximum = Number(root.dataset.maxReleases) || 24;
      const locale = root.dataset.locale || document.documentElement.lang || 'en';
      const nextLabelTemplate = root.dataset.nextLabel || 'See more __MONTH__ releases';
      let cards = [...source.querySelectorAll('[data-ftbm-archive-card]')];

      cards.sort((left, right) => new Date(right.dataset.end) - new Date(left.dataset.end));
      cards.slice(maximum).forEach((card) => card.remove());
      cards = cards.slice(0, maximum);

      const monthFormatter = new Intl.DateTimeFormat(locale, { month: 'long', timeZone: 'UTC' });
      const groups = new Map();

      cards.forEach((card, index) => {
        const date = new Date(card.dataset.end);
        if (Number.isNaN(date.getTime())) return;

        const year = String(date.getUTCFullYear());
        const monthNumber = String(date.getUTCMonth() + 1).padStart(2, '0');
        const key = `${year}-${monthNumber}`;

        card.querySelector('[data-ftbm-archive-index]').textContent = String(index + 1).padStart(2, '0');

        if (!groups.has(key)) {
          groups.set(key, {
            year,
            month: monthFormatter.format(date),
            cards: []
          });
        }

        groups.get(key).cards.push(card);
      });

      groups.forEach((group) => {
        const monthSection = document.createElement('section');
        monthSection.className = 'ftbm-archive-month';

        const dateHeader = document.createElement('header');
        dateHeader.className = 'ftbm-archive-month__date';

        const year = document.createElement('span');
        year.className = 'ftbm-archive-month__year';
        year.textContent = group.year;

        const month = document.createElement('h3');
        month.className = 'ftbm-archive-month__name';
        month.textContent = group.month;

        const slider = document.createElement('div');
        slider.className = 'ftbm-archive-month__slider';

        const rail = document.createElement('div');
        rail.className = 'ftbm-archive__rail';

        const next = document.createElement('button');
        next.className = 'ftbm-archive-month__next';
        next.type = 'button';
        next.setAttribute('aria-label', nextLabelTemplate.replace('__MONTH__', group.month));

        group.cards.forEach((card) => rail.append(card));
        dateHeader.append(year, month);
        slider.append(rail, next);
        monthSection.append(dateHeader, slider);
        monthsRoot.append(monthSection);

        const updateNavigation = () => {
          const isScrollable = rail.scrollWidth > rail.clientWidth + 2;
          const canScroll = rail.scrollLeft + rail.clientWidth < rail.scrollWidth - 2;
          slider.classList.toggle('is-scrollable', isScrollable);
          next.classList.toggle('can-scroll', canScroll);
          next.hidden = !isScrollable;
          next.disabled = !canScroll;
        };

        next.addEventListener('click', () => {
          const firstCard = rail.querySelector('.ftbm-archive-card');
          const gap = parseFloat(getComputedStyle(rail).columnGap || '12');
          rail.scrollBy({
            left: firstCard.getBoundingClientRect().width + gap,
            behavior: 'smooth'
          });
        });

        rail.addEventListener('scroll', updateNavigation, { passive: true });

        new ResizeObserver(updateNavigation).observe(rail);
        requestAnimationFrame(updateNavigation);
      });

      source.hidden = true;
      root.dataset.initialized = 'true';

      const canPreviewVideo =
        window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (canPreviewVideo) {
        root.querySelectorAll('.ftbm-archive-card').forEach((card) => {
          const video = card.querySelector('.ftbm-archive-card__video');
          if (!video) return;

          const play = () => video.play().catch(() => {});
          const reset = () => {
            video.pause();
            try {
              video.currentTime = 0;
            } catch (error) {
              return;
            }
          };

          card.addEventListener('pointerenter', play);
          card.addEventListener('pointerleave', reset);
          card.addEventListener('focusin', play);
          card.addEventListener('focusout', (event) => {
            if (!card.contains(event.relatedTarget)) reset();
          });
        });
      }
    };

    const initializeAll = () => {
      document.querySelectorAll('[data-ftbm-archive]').forEach(initializeArchive);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-offer-bar"] && !Shopify.designMode) return;
  try {
    
    window.addEventListener('load', (event) => {
        const thisBar = document.querySelector('.shoplift-offer--bar--sticky');

        if (thisBar != null) {
            const thisHeader = document.querySelector('.shoplift-offerbar-wrapper');
            thisHeader.classList.add("shoplift-offer-bar-sticky");

            const mainHeader = document.querySelector('#shopify-section-header > sticky-header');

            const mainInitialTop = mainHeader.offsetTop;
            const stickyStart = mainHeader ? (mainHeader.offsetTop + mainHeader.clientHeight) : 0;
            let lastScroll = window.scrollY;
            document.addEventListener("scroll", (scrollEvent) => {
                if (!thisHeader) return;

                // Do it quick and dirty
                const mainHidden = mainHeader && (window.scrollY > lastScroll);
                lastScroll = window.scrollY;

                const makeSticky = window.pageYOffset > stickyStart || mainHeader && window.pageYOffset > mainInitialTop && mainHeader.parentElement.classList.contains("shopify-section-header-sticky");

                thisHeader.classList.toggle("shoplift-offer-bar-sticky", makeSticky);

                if (!makeSticky) return;

                let topPosition = 0;

                if (mainHeader && !mainHidden)
                    topPosition += mainHeader.clientHeight;

                thisHeader.style.top = topPosition + "px";
            });
        }
    });

  } catch(e) { console.error(e); }
})();
})();
